import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { loadPdtCate } from '@app/actions/shoppingmall/pdt-cate.action';
import { loadSpecialProducts, loadTotalSpecialProducts } from '@app/actions/shoppingmall/product.action';
import { AuthUtil } from '@app/common/util/auth.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { PdtCateModel } from '@app/models/shoppingmall/pdt-cate.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { PdtCateState, getPdtCates } from '@app/selectors/shoppingmall/pdt-cate.selector';
import { ProductState, getBestProducts, getTotalBestProducts } from '@app/selectors/shoppingmall/product.selector';
import { SmWownetState, getSmWownet } from '@app/selectors/system/sm-wownet.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { PaginationInstance } from 'ngx-pagination';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'hp-best',
  templateUrl: './hp-best.component.html',
  styleUrls: ['./hp-best.component.css']
})
export class HpBestComponent implements OnInit {

  smWownet$ = new Observable<SmWownetModel>();
  smWownet: any = {} as SmWownetModel;
  urlWownet : String = "";

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];

  pdtCates$ = new Observable<PdtCateModel[]>;
  contentsPdtCates : any = "";

  cateCd: string = "";

  pathKind: string = "PC";
  page: number = 1;
  len: number = 10;
  activeId: string = "0700";

  total$ = new Observable<number>();
  total: number = 0;

  config: PaginationInstance = {
		id: 'best-product',
		itemsPerPage: this.len,
    currentPage: this.page,
    totalItems: this.total,
	};

  isLogined: boolean = false;
  pagination: boolean = true;

  constructor(
    private _router: Router,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _productStore: Store<ProductState>,
    private _pdtCateStore: Store<PdtCateState>,   
    private _smWownetStateStore: Store<SmWownetState>,
  ) {
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    this.products$ = this._productStore.select(getBestProducts);
    this.total$ = this._productStore.select(getTotalBestProducts);
    this.pdtCates$ = this._pdtCateStore.select(getPdtCates);
   }

  ngOnInit(): void {

    this.smWownet$.subscribe((res) => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.urlWownet = res.urlWownet;
          this.smWownet = res;
      }
    });

    this.loadTotalProducts();
    this.loadProducts();
    this.isLogined = AuthUtil.isLogined();

    this._pdtCateStore.dispatch(loadPdtCate({ key: "" }));
    this.pdtCates$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.contentsPdtCates = res;
      }
    });

    this.total$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.total = res;
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this.products$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.products = res;
      } else {
        this.products = [];
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });
  }

  loadTotalProducts(): void {
    const params = this.getParams();

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._productStore.dispatch(loadTotalSpecialProducts({ params: params }));
  }

  loadProducts(): void {
    const params = this.getParams();

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._productStore.dispatch(loadSpecialProducts({ params: params }));
  }

  getParams(): any {

    const params = {
      comId: environment.comId,
      cateCd: this.activeId,
      pathKind: this.pathKind,
      type: '4',
      userId: AuthUtil.getUserId(),
      page: this.page - 1,
      len: this.len,
    }

    return params;
  }

  handleClickCate(cateCd: string) {
    this.activeId = cateCd;

    this.loadTotalProducts();
    this.loadProducts();
  }

  onChangePage(page: number): void {
    this.page = page;
    this.config.currentPage = page;

    this.loadProducts();
  }
}
